import React from 'react';

import TradingEventsFilters from './TradingEventsFilters';
import { TradingEventsList } from './TradingEventsList/TradingEventsList';
import { RecentEventsList } from 'src/components/TradingEvents/RecentEventsList/RecentEventsList';
import { NextEventsList } from 'src/components/TradingEvents/NextEventsList/NextEventsList';
import { TradingEventsListState } from './TradingEventsList/TradingEventsList.state';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import {
    TradingEventsContent,
    TradingEventsListWrapper,
    TradingEventsOtherWrapper,
} from 'src/components/TradingEvents/TradingEvents.style';

export const TradingEvents = observer('TradingEvents', () => {
    const appState = useAppStateContext();
    const [tradingEventsListState] = React.useState(
        () => new TradingEventsListState(appState.sdkStaff, appState.routerBackoffice, appState.sportsbookState)
    );

    return (
        <>
            <TradingEventsFilters
                className='trading-events-filters'
                onChange={tradingEventsListState.dispatchFilter}
                data={tradingEventsListState.filters}
            />
            <TradingEventsContent>
                <TradingEventsListWrapper>
                    <TradingEventsList tradingEventsListState={tradingEventsListState} />
                </TradingEventsListWrapper>

                <TradingEventsOtherWrapper>
                    <h3>Recently viewed</h3>
                    <RecentEventsList />

                    <h3>Next events</h3>
                    <NextEventsList />
                </TradingEventsOtherWrapper>
            </TradingEventsContent>
        </>
    );
});
